<template>
  <div>
    <div class="topbar">
      <div class="brand" @click="backToOrder">&#8249; 预咨询</div>
    </div>
    <div class="content">
      <div v-if="order" class="card order-summary">
        <div class="row">
          <div class="slot-title">{{ order.slotTitle }}</div>
          <div class="price">¥{{ (order.orderTotalAmount / 100).toLocaleString("zh-CN") }}</div>
        </div>
        <div class="muted expert-name">{{ order.expertName }}</div>
      </div>

      <div v-if="confirming" class="card confirm-card">
        <div class="spinner"></div>
        <div>正在确认支付结果，请稍候...</div>
      </div>

      <template v-else-if="canEdit">
        <div class="card">
          <div class="form-title">选题方向或咨询说明</div>
          <div class="muted form-tip">描述你的选题方向、当前困惑或希望专家重点关注的问题</div>
          <textarea
            class="input consult-input"
            v-model="form.consultNote"
            maxlength="1000"
            placeholder="例如：计划申报某方向课题，目前不确定研究方法和技术路线，希望专家帮助梳理"
          ></textarea>
          <div class="word-count">{{ form.consultNote.length }}/1000</div>
        </div>

        <div class="card">
          <div class="form-title">上传稿件（选填）</div>
          <div class="muted form-tip">支持 Word、PDF 格式，便于专家提前了解材料</div>
          <div v-if="form.manuscriptUrl" class="existing-file">
            <a :href="form.manuscriptUrl" target="_blank">查看已上传材料</a>
            <button type="button" @click="form.manuscriptUrl = ''">移除</button>
          </div>
          <Upload
            list-type="file"
            dir="user/nrc/order/manuscript"
            accept=".doc,.docx,.pdf"
            :allow-ext="['doc', 'docx', 'pdf']"
            @uploadStart="uploading = true"
            @uploadSuccess="onUploadSuccess"
            @uploadFail="uploading = false"
            @delete="form.manuscriptUrl = ''"
          />
        </div>

        <button class="btn" :disabled="uploading || saving" @click="save">
          {{ saving ? "保存中..." : "保存并进入订单详情" }}
        </button>
        <button class="skip-btn" type="button" @click="backToOrder">稍后填写</button>
      </template>

      <div v-else-if="order" class="card confirm-card">
        <div>暂未确认到支付结果</div>
        <div class="muted retry-tip">如果已经完成支付，请稍候刷新</div>
        <button class="btn sm" @click="startConfirm">重新查询</button>
      </div>
    </div>
  </div>
</template>

<script>
import { orderDetail, updateOrderExtra } from "@/api/nrc.js";
import Upload from "@/components/Upload/Upload.vue";
import { Toast } from "vant";

export default {
  name: "OrderConsult",
  components: { Upload },
  data() {
    return {
      order: null,
      form: { consultNote: "", manuscriptUrl: "" },
      confirming: false,
      confirmAttempts: 0,
      confirmTimer: null,
      uploading: false,
      saving: false,
    };
  },
  computed: {
    canEdit() {
      return this.order && this.order.orderStatus === 1;
    },
  },
  created() {
    this.startConfirm();
  },
  beforeDestroy() {
    clearTimeout(this.confirmTimer);
  },
  methods: {
    startConfirm() {
      clearTimeout(this.confirmTimer);
      this.confirmAttempts = 0;
      this.confirming = true;
      this.loadOrder();
    },
    loadOrder() {
      orderDetail(this.$route.params.id)
        .then((order) => {
          this.order = order;
          this.form.consultNote = order.consultNote || "";
          this.form.manuscriptUrl = order.manuscriptUrl || "";
          if (order.orderStatus === 1) {
            this.confirming = false;
            return;
          }
          if (order.orderStatus === 0 && this.confirmAttempts < 10) {
            this.confirmAttempts += 1;
            this.confirmTimer = setTimeout(this.loadOrder, 1000);
            return;
          }
          this.confirming = false;
        })
        .catch(() => {
          this.confirming = false;
        });
    },
    onUploadSuccess(url) {
      this.uploading = false;
      this.form.manuscriptUrl = url;
    },
    save() {
      if (this.uploading) {
        Toast("稿件正在上传，请稍候");
        return;
      }
      this.saving = true;
      updateOrderExtra({
        orderId: this.order.id,
        consultNote: this.form.consultNote.trim(),
        manuscriptUrl: this.form.manuscriptUrl,
      })
        .then(() => {
          Toast.success("预咨询信息已保存");
          this.backToOrder();
        })
        .finally(() => {
          this.saving = false;
        });
    },
    backToOrder() {
      this.$router.replace(`/order/${this.$route.params.id}`);
    },
  },
};
</script>

<style scoped>
.order-summary { margin-bottom: 14px; }
.slot-title { font-size: 18px; font-weight: 600; }
.expert-name { margin-top: 8px; }
.form-title { font-size: 16px; font-weight: 600; }
.form-tip { margin: 7px 0 12px; font-size: 13px; line-height: 1.6; }
.consult-input { min-height: 130px; box-sizing: border-box; line-height: 1.6; resize: vertical; }
.word-count { margin-top: 5px; color: #aaa; text-align: right; font-size: 12px; }
.existing-file { display: flex; align-items: center; justify-content: space-between; margin-bottom: 12px; padding: 10px 12px; border-radius: 8px; background: #f4fbfc; font-size: 13px; }
.existing-file a { color: var(--color-primary); }
.existing-file button { border: 0; background: transparent; color: #f56c6c; }
.confirm-card { margin-top: 22vh; color: #666; text-align: center; }
.spinner { width: 34px; height: 34px; margin: 0 auto 16px; border: 3px solid #d9eef1; border-top-color: var(--color-primary); border-radius: 50%; animation: spin .8s linear infinite; }
.retry-tip { margin: 8px 0 16px; font-size: 13px; }
.skip-btn { display: block; margin: 16px auto 0; padding: 8px 18px; border: 0; background: transparent; color: #909399; font-size: 14px; }
@keyframes spin { to { transform: rotate(360deg); } }
</style>
